import React, { useCallback } from "react";

import { LoadingButton } from "@mui/lab";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { Close as ErrorIcon, Check as SuccessIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const variants = {
  success: SuccessIcon,
  error: ErrorIcon,
};

const bgVariants = {
  success: "#5cb85c",
  error: "red",
};

const CustomAlert = ({
  isOpen,
  title = "",
  subTitle = "",
  content = "",
  onClick,
  variant,
}) => {
  const onConfirmClick = useCallback(() => {
    onClick();
  }, [onClick]);

  const Icon = variants[variant];
  const bgcolor = bgVariants[variant];
  const { t } = useTranslation();

  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isOpen}
    >
      <Box
        sx={{
          background: "white",
          width: "480px",
          maxWidth: "95vw",
          p: 2,
          borderRadius: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box display={"flex"} flexDirection={"column"}>
          <Typography
            fontSize={20}
            color={"#323130"}
            variant="h5"
            align="center"
          >
            {title}
          </Typography>
          <Typography
            sx={{ textAlign: "center" }}
            color={"#605E5C"}
            align="center"
          >
            {subTitle}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <IconButton
              onClick={() => {}}
              disableRipple={true}
              sx={{
                backgroundColor: bgcolor,
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "3px 3px 10px rgba(0, 0, 0, 0.2)",
                padding: 0,
                lineHeight: 0,
              }}
            >
              <Icon
                sx={{
                  width: "40px",
                  height: "40px",
                  color: "white",
                  marginTop: 0,
                }}
              />
            </IconButton>
          </Box>
          <Typography
            sx={{ textAlign: "center" }}
            color={"#605E5C"}
            align="center"
            style={{
              color: variant === "error" ? "red" : "black",
              fontWeight: "bold",
            }}
          >
            {content}
          </Typography>

          <Box mt={2} display={"flex"} justifyContent={"space-around"}>
            <LoadingButton
              size="small"
              sx={{ width: "150px", height: "40px" }}
              loading={false}
              color="primary"
              onClick={onConfirmClick}
              variant="contained"
            >
              {t("commonLabels.text18")}
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(CustomAlert);
